function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { styleNames, styleNamePropType } from '../../propTypes/commonComponent';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import '../../styles/components/common/Buttons.css';
var APButton = function APButton(props) {
  var children = props.children,
    styleName = props.styleName,
    baseClass = props.baseClass,
    customClass = props.customClass,
    classModifiers = props.classModifiers,
    disabled = props.disabled,
    dataTest = props.dataTest,
    otherProps = _objectWithoutProperties(props, ['children', 'styleName', 'baseClass', 'customClass', 'classModifiers', 'disabled', 'dataTest']);
  var bemClasses = getBEMClasses(baseClass, customClass, classModifiers);
  return React.createElement(React.Fragment, null, React.createElement('button', Object.assign({
    disabled: disabled,
    'data-test': dataTest,
    className: bemClasses('btn', [styleName, classModifiers])
  }, otherProps), children));
};
APButton.defaultProps = {
  name: '',
  value: '',
  type: '',
  autoFocus: false,
  disabled: false,
  baseClass: 'ap-button',
  styleName: styleNames.general
};
APButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  baseClass: PropTypes.string,
  customClass: PropTypes.string,
  styleName: styleNamePropType
};
APButton.contextTypes = {
  t: PropTypes.func.isRequired
};
export default APButton;